import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { RouteService } from '../../../services/route.service';

@Component({
    selector: 'app-initialization-loading-indicator',
    templateUrl: './initialization-loading-indicator.component.html',
    styleUrls: ['./initialization-loading-indicator.component.scss'],
    standalone: true
})
export class InitializationLoadingIndicatorComponent implements OnChanges {

    @Input() failed: boolean;
    @Input() loading: boolean;

    bookListLink: string;

    constructor(public applicationStateService: ApplicationStateService,
                private routeService: RouteService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.applicationStateService.bookConfig) {
            this.bookListLink = this.routeService.getBookListLink();
        }
    }

    goBack(): void {
        window.history.back();
    }
}
